import { render, staticRenderFns } from "./sort-icons.vue?vue&type=template&id=ec703622"
import script from "./sort-icons.vue?vue&type=script&lang=js"
export * from "./sort-icons.vue?vue&type=script&lang=js"
import style0 from "./sort-icons.vue?vue&type=style&index=0&id=ec703622&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports